import { Jsx_t, String_t, Trans_t } from "mfe-lib-bfo-shared";

type UseJsxTProps = {
    k: string;
    options?: Record<string, any>;
};
type UseTransTProps = {
    k: string;
    components?: any;
    values?: any;
};

const NAMESPACE = "stitcher";

export function UseJsxT({ k, options }: UseJsxTProps) {
    return <Jsx_t k={k} options={options} namespace={NAMESPACE} />;
}
export function useStringT(k: string, options?: Record<string, any>) {
    return String_t(k, NAMESPACE, options);
}
export function UseTransT({ k, components, values }: UseTransTProps) {
    return <Trans_t k={k} namespace={NAMESPACE} components={components} values={values} />;
}
